import { toast } from "react-hot-toast";

import {
  setLoading,
  setUser,
} from "../../features/student/slices/profileSlice";
import { apiConnector } from "../api/client";
import { profileEndpoints } from "../api/endpoints";
import { logout } from "./authAPI";

const {
  GET_USER_DETAILS_API,
  GET_USER_ENROLLED_COURSES_API,
  GET_INSTRUCTOR_DATA_API,
} = profileEndpoints;

export function getUserDetails(token, navigate) {
  return async (dispatch) => {
    const toastId = toast.loading("Loading...");
    dispatch(setLoading(true));
    try {
      const response = await apiConnector("GET", GET_USER_DETAILS_API, null, {
        Authorization: `Bearer ${token}`,
      });
      console.log("GET_USER_DETAILS API RESPONSE............", response);

      if (!response.data.success) {
        throw new Error(response.data.message);
      }
      const userImage = response.data.data.image
        ? response.data.data.image
        : `https://api.dicebear.com/5.x/initials/svg?seed=${response.data.data.firstName} ${response.data.data.lastName}`;
      dispatch(setUser({ ...response.data.data, image: userImage }));
    } catch (error) {
      dispatch(logout(navigate));
      console.log("GET_USER_DETAILS API ERROR............", error);
      toast.error("Could Not Get User Details");
    }
    toast.dismiss(toastId);
    dispatch(setLoading(false));
  };
}

export async function getUserEnrolledCourses(token) {
  if (!token) {
    throw new Error("Authentication token is missing");
  }

  const toastId = toast.loading("Loading...");
  let result = [];
  try {
    console.log("BEFORE Calling BACKEND API FOR ENROLLED COURSES");
    const response = await apiConnector(
      "GET",
      GET_USER_ENROLLED_COURSES_API,
      null,
      {
        Authorization: `Bearer ${token}`,
      }
    );
    console.log("AFTER Calling BACKEND API FOR ENROLLED COURSES");
    console.log("Response data:", response.data);

    if (!response.data.success) {
      throw new Error(
        response.data.message || "Failed to get enrolled courses"
      );
    }

    // Ensure we have valid data
    if (!response.data.data || !Array.isArray(response.data.data)) {
      console.error("Invalid data format received:", response.data);
      throw new Error("Invalid data format received from server");
    }

    result = response.data.data;
  } catch (error) {
    console.log("GET_USER_ENROLLED_COURSES_API API ERROR............", error);
    console.log("Error response:", error.response?.data);

    // Don't show toast for 401 errors as they are handled by the interceptor
    if (error.response?.status !== 401) {
      toast.error("Could Not Get Enrolled Courses");
    }
    // Re-throw the error so the component can handle it
    throw error;
  } finally {
    toast.dismiss(toastId);
  }
  return result;
}

export async function getInstructorData(token) {
  const toastId = toast.loading("Loading...");
  let result = [];
  try {
    const response = await apiConnector("GET", GET_INSTRUCTOR_DATA_API, null, {
      Authorization: `Bearer ${token}`,
    });

    console.log("GET_INSTRUCTOR_API_RESPONSE", response);
    // Response structure: { data: { success, message, data: { courses: [...] } } }
    result = response?.data?.data?.courses || [];
  } catch (error) {
    console.log("GET_INSTRUCTOR_API ERROR", error);
    toast.error("Could not Get Instructor Data");
  }
  toast.dismiss(toastId);
  return result;
}
